import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronsUp, Flame, Trophy } from 'lucide-react';
import { formatMatchTime, formatOdd, matchHref } from '../../lib/topMatches';

// Kartlar sırayla bu tonlardan birini alır; şerit tek renk bir blok gibi
// görünmesin diye (referans tasarımda turuncu ve mavi kartlar yan yana durur).
export const MATCH_TONES = ['orange', 'blue', 'green'];

export const matchTone = (index) => MATCH_TONES[Math.abs(Number(index) || 0) % MATCH_TONES.length];

/**
 * Kartın dikey çizgideki satırları: lig, başlama ve spor dalı. Boş alan
 * satır üretmez — uydurma bir lig ya da saat yazılmaz.
 */
export const matchDetails = (match, now = new Date()) => {
  const rows = [];
  if (match?.league) rows.push({ label: 'Lig', value: match.league });
  if (match?.live) {
    rows.push({ label: 'Durum', value: 'Canlı' });
  } else {
    const time = formatMatchTime(match?.start_at, now);
    if (time) rows.push({ label: 'Başlama', value: time });
  }
  if (match?.sport) rows.push({ label: 'Spor', value: match.sport });
  return rows;
};

/**
 * Ana sayfanın "Öne Çıkan Maçlar" kartı: başlıkta iki takım (sığmazsa iki
 * satıra kırılır, kırpılmaz), noktalı çizgide lig ve saat, altta ana market
 * oranları. Oranlar **dokunulabilir değildir** — hazır spor kitabının kuponu
 * sağlayıcının çerçevesindedir; kartın tamamı spor sayfasını açar.
 */
const BetrunMatchCard = ({ match, index = 0 }) => {
  const title = `${match.home} - ${match.away}`;
  const details = matchDetails(match);
  const odds = match.odds || [];

  return (
    <Link
      to={matchHref(match)}
      className={`betrun-match is-${matchTone(index)}`}
      data-bhs="match-card"
    >
      {match.live && (
        <span className="betrun-match-live">
          <Flame size={13} aria-hidden="true" />
          CANLI
        </span>
      )}
      <div className="betrun-match-head">
        <span className="betrun-match-icon" aria-hidden="true">
          <Trophy size={16} />
        </span>
        <h3 className="betrun-match-title" title={title}>
          <span>{match.home}</span>
          <span className="betrun-match-sep"> - </span>
          <span>{match.away}</span>
        </h3>
      </div>
      {details.length > 0 && (
        <ul className="betrun-match-lines">
          {details.map((row) => (
            <li key={row.label}>
              <span className="betrun-match-line-label">{row.label}:</span>
              <span className="betrun-match-line-value">{row.value}</span>
            </li>
          ))}
        </ul>
      )}
      <div className="betrun-match-bar">
        {odds.length > 0 ? (
          <>
            <ChevronsUp size={18} className="betrun-match-bar-icon" aria-hidden="true" />
            {odds.map((odd, oddIndex) => (
              <span key={`${odd.label}-${oddIndex}`} className="betrun-match-odd">
                <small>{odd.label}</small>
                <b>{formatOdd(odd.price)}</b>
              </span>
            ))}
          </>
        ) : (
          <span className="betrun-match-cta">Maça Git</span>
        )}
      </div>
    </Link>
  );
};

export default BetrunMatchCard;
